import { useCallback } from 'react';
import { useEventLogger, useNavigationHelper } from 'FrontRoyalAngular';
import { type StreamForStreamDashboard, type StreamSummary } from 'Lessons';
import { getStreamLogInfo } from '../selectors';

/*
    Opens a course summary PDF in a new tab, and logs course_summary_view first.

    Replaces onLessonSummaryClick in Stream.SummaryHelperMixin. That mixin stays where it is, because
    lesson_finish_screen_dir also uses it, but the payload is reproduced here: the summary's id and
    title, merged over the stream's log info.
*/
export function useOpenSummary(stream: StreamForStreamDashboard | null, summaries: StreamSummary[]) {
    const EventLogger = useEventLogger();
    const { loadUrl } = useNavigationHelper();

    return useCallback(
        (summaryId: string) => {
            const summary = summaries.find(candidate => candidate.id === summaryId);
            if (!summary || !stream) return;

            EventLogger.log('course_summary_view', {
                summary_id: summary.id,
                label: summary.title,
                ...getStreamLogInfo(stream),
            });

            loadUrl(summary.url, '_blank');
        },
        [stream, summaries, EventLogger, loadUrl],
    );
}
